'use client';

import React from 'react';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { Typography } from 'src/components';
import useTableFilterSelections from 'src/hooks/filters/useTableFilterSelections';

const NewEncountersVolumeCell = ({ row, field, searchId }) => {
  const isHere = field.includes('here') ? true : false;
  const { showEncountersTotals } = useFlags();

  // Get the apiVolumeFilterFormat which contains settings for all columns
  const { apiVolumeFilterFormat } = useTableFilterSelections();

  // Get the column settings for this specific searchId (composite key)
  let columnSettings = apiVolumeFilterFormat[searchId];

  // Fallback: if searchId lookup fails, try to find any settings in apiVolumeFilterFormat
  if (!columnSettings && Object.keys(apiVolumeFilterFormat).length > 0) {
    // Use the first available composite key settings as fallback
    const firstAvailableKey = Object.keys(apiVolumeFilterFormat)[0];
    columnSettings = apiVolumeFilterFormat[firstAvailableKey];
  }

  // Get the type from the column settings, default to 'claims' if not found
  const columnType = columnSettings?.type || 'claims';

  // For encounters (cohort) columns, source the claims value from encounters
  // instead (label unchanged). Gated by the flag; only swaps the claims metric.
  const isEncounters = !!showEncountersTotals && !!columnSettings?.cohort_id;

  const claimsValue = isHere ? row.claims_at_location : row.claims_total;
  const patientsValue = isHere ? row.patients_at_location : row.patients_total;
  const encountersValue = isHere
    ? row.encounters_at_location
    : row.encounters_total;

  const cellValue =
    columnType === 'patients'
      ? patientsValue
      : isEncounters
        ? encountersValue
        : claimsValue;

  return (
    <Typography className="text-base font-normal text-primary">
      {cellValue?.[searchId] || '-'}
    </Typography>
  );
};

export default NewEncountersVolumeCell;
